var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecklist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_852_504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 13.75H10V15H18.75V13.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 12.125L7.875 11.25L3.75 15.375L2.125 13.75L1.25 14.625L3.75 17.125L8.75 12.125Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 5H10V6.25H18.75V5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 3.375L7.875 2.5L3.75 6.625L2.125 5L1.25 5.875L3.75 8.375L8.75 3.375Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_852_504"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.f4ff5d8aa6d1f410ecad8370ad0d820a.svg";
export { ForwardRef as ReactComponent };